import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ImageLocation } from 'src/utils/URLUtils';
import styles from './LexiSection.module.scss';

const LexiSection = () => {
    //  const { open } = useIFrameModal();
    // const { userInfo } = useUser();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    // const { learningInfo } = useLearning();
    const [loadedImages, setLoadedImages] = useState<{ [key: string]: boolean }>({});

    const handleClick = (section: string) => {
        if (section === 'Speaking') {
            navigate(`/chat?section=general-chat`);
            // open(GetRazorSiteUrl(`practice/general-chat`, userInfo?.Token)
            //     , `Talk With Lexi`);
        }
        else if (section === 'Writing') {
            navigate(`/chat?section=writing`);
            // open(GetRazorSiteUrl(`practice/writing`, userInfo?.Token)
            //     , `Writing Practice`);
        }
        else if (section === 'Vocabulary') {
            navigate(`/chat?section=word-chat`);
            // open(GetRazorSiteUrl(`practice/word-chat`,
            //     userInfo?.Token, `wordId=${learningInfo?.UnknownWordIds[0]}`)
            //     , `Let's Practice`);
        }
    }

    const handleImageLoad = (section: string) => {
        setLoadedImages(prev => ({ ...prev, [section]: true }));
    };

    return (
        <section className={styles.lexiSection}>
            <h2 className='homeTitle'>{t('Practice with Lexi')}</h2>
            <p dir={i18n.dir()} className='homeSubtitle'>{t('Your AI tutor for reading, writing and speaking.')}</p>

            <div className={styles.cardContainer}>
                <div className={styles.card}
                    onClick={() => handleClick('Vocabulary')}>
                    <img
                        src={ImageLocation('Lexi/Lexi-Vocabulary2.png?w=100')}
                        alt={t('Vocabulary')}
                        loading="eager"
                        className={`${loadedImages['Vocabulary'] ? styles.loaded : ''}`}
                        onLoad={() => handleImageLoad('Vocabulary')}
                    />
                    <h3>{t('Vocabulary')}</h3>
                </div>
                <div className={styles.card} onClick={() => handleClick('Writing')}>
                    <img
                        src={ImageLocation('Lexi/Lexi-Writing2.png?w=100')}
                        alt={t('Writing')}
                        loading="eager"
                        className={`${loadedImages['Writing'] ? styles.loaded : ''}`}
                        onLoad={() => handleImageLoad('Writing')}
                    />
                    <h3>{t('Writing')}</h3>
                </div>
                <div className={styles.card} onClick={() => handleClick('Speaking')}>
                    <img
                        src={ImageLocation('Lexi/Lexi-Speaking2.png?w=100')}
                        alt={t('Speaking')}
                        loading="eager"
                        className={`${loadedImages['Speaking'] ? styles.loaded : ''}`}
                        onLoad={() => handleImageLoad('Speaking')}
                    />
                    <h3>{t('Speaking')}</h3>
                </div>
            </div>
        </section >
    );
};

export default LexiSection;
